import { RestService } from '../restService';
import { ExtendedClientDetails } from '../../models/coachingNavigator/extendedClientDetails';

export class ExtendedClientDetailsService extends RestService<ExtendedClientDetails> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }

    // Backend route: GET /extendedClientId/:id
    public async get(id: string): Promise<ExtendedClientDetails> {
        const client = await this.axiosFactory();
        const response = await client.request<ExtendedClientDetails>({
            method: 'GET',
            url: `/extendedClientId/${id}`,
        });

        return response?.data as ExtendedClientDetails;
    }

    // Backend route: GET /all/:creator
    public async getByCreator(creatorEmail: string): Promise<ExtendedClientDetails[]> {
        if (!creatorEmail) return [];
        const client = await this.axiosFactory();
        const response = await client.request<ExtendedClientDetails[]>({
            method: 'GET',
            url: `/all/${creatorEmail}`,
        });

        return response?.data || [];
    }
}
